var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.276.724a1.333 1.333 0 00-1.885 0L7 5.114 2.61.725A1.333 1.333 0 00.723 2.609L5.114 7l-4.39 4.39a1.333 1.333 0 101.885 1.886L7 8.886l4.39 4.39a1.333 1.333 0 001.886-1.885L8.886 7l4.39-4.39a1.333 1.333 0 000-1.886z",
    fill: "#fff"
  })));
}
export default SvgCross;